import React from 'react';
import './LogoHeader.css';
import { styled } from '@mui/material/styles';
import CardMedia from '@mui/material/CardMedia';
import flow from '../../flow.svg';
import { Typography } from '@mui/material';

/**
 * A logo component designed for the header. It displays a logo image and an alternative text if the image is not available.
 * The logo is styled using Material-UI and includes a fallback icon (`flow.svg`) and text.
 * 
 * @component
 * @example
 * import LogoHeader from '../../Components/LogoHeader/LogoHeader';
 * <LogoHeader img={logo} alt={client} />
 * @param {string} img - The URL of the logo image to display.
 * @param {string} alt - The alternative text to display if the logo image is not available.
 * @returns {React.Component} The rendered logo header component.
 */
function LogoHeader({ img, alt }) {
  /**
   * A styled `CardMedia` component for the logo image. It applies custom styles for height, width, and positioning.
   */
  const HeaderLogo = styled(CardMedia)({
    height: '49px',
    objectFit: 'contain',
    width: '77px',
    zIndex: 1
  });

  return img ? (
    <>
    <img src={flow} className="flowIcon" alt='flow'/>
    <HeaderLogo
      component="img"
      className="header_logo"
      image={img}
      alt={"Logo " + alt}
    />
    <Typography color="darkblue" fontSize="41px" fontWeight='fontWeightBold' letterSpacing="-3px" ml="-23px">LBA</Typography>
    </>
  ) : null;
}

export default LogoHeader;